import jqRequest from '../jqRequest'
import commUrls from '../urls/common'

export default {
  // 获取手机验证码
  getAuthCode(data) {
    return jqRequest.requestWithToken(commUrls.getAuthCode, data);
  },
  // 刷新token
  refreshToken(data){
    return jqRequest.requestWithContentType(commUrls.refreshToken, data);
  },
  // 获取用户信息
  getMemberByToken(data) {
    return jqRequest.requestWithToken(commUrls.getMemberByToken, data);
  },
  // 点击访问量
  clickPlayCount(data) {
    return jqRequest.requestWithToken(commUrls.clickPlayCount, data);
  },
  // 中宣部访问
  addH5Escalate(data) {
    return jqRequest.requestWithContentTypeAndToken(commUrls.addH5Escalate, JSON.stringify(data));
  },
  // 增加积分
  addScore(data) {
    return jqRequest.requestWithToken(commUrls.addScore, data);
  },
  // 获取新闻评论列表
  getCommentListByNewsId(data) {
    return jqRequest.requestWithToken(commUrls.getCommentListByNewsId, data);
  },
  // 评论提交
  addComment(data){
    return jqRequest.requestWithToken(commUrls.addComment, data);
  },
  // 获取点赞状态
  queryThumbsUpStatus(data){
    return jqRequest.requestWithToken(commUrls.queryThumbsUpStatus, data);
  },
  // 点赞
  giveThumbsUp(data) {
    return jqRequest.requestWithToken(commUrls.giveThumbsUp, data);
  },
  // 取消点赞
  cancelThumbsUp(data) {
    return jqRequest.requestWithToken(commUrls.cancelThumbsUp, data);
  },
  // 评论点赞
  giveThumbsUpComment(data) {
    return jqRequest.requestWithToken(commUrls.giveThumbsUpComment, data);
  },
  // 获取点赞类型及相关图标
  getAppFunButtonConfigNew(data){
    return jqRequest.requestWithToken(commUrls.getAppFunButtonConfigNew, data);
  },
  // 收藏
  addMemberCollect(data) {
    return jqRequest.requestWithToken(commUrls.addMemberCollect, data);
  },
  // 取消收藏
  cancelMemberCollect(data) {
    return jqRequest.requestWithToken(commUrls.cancelMemberCollect, data);
  },
  //获取微信Ticket
  getWeiXinTicket(data) {
    return jqRequest.requestWithToken(commUrls.getWeiXinTicket, data);
  }
}